function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4.815 5.092l.08.085 1.657 1.942 2.374 8.86c.93.07 1.74.566 2.24 1.292l7.39-1.98 2.077.586.113.03c.439.143.724.572.685 1.033l-.016.116-.03.113c-.143.439-.572.724-1.033.685l-.115-.016-1.617-.494-6.937 1.86c-.12 1.547-1.413 2.765-2.991 2.765-1.657 0-3-1.343-3-3 0-1.026.515-1.932 1.301-2.473L4.737 8.072 3.374 6.474c-.333-.39-.313-.962.027-1.329l.085-.08c.39-.333.962-.314 1.329.027zM7.692 18.97c0 .552.447 1 1 1 .552 0 1-.448 1-1s-.448-1-1-1c-.553 0-1 .448-1 1zm7.553-14.18c1.067-.285 2.164.348 2.45 1.415l1.294 4.83c.286 1.067-.347 2.163-1.414 2.45l-4.83 1.293c-1.067.286-2.164-.347-2.45-1.414l-1.294-4.83c-.286-1.066.348-2.163 1.415-2.449l4.83-1.294zm.518 1.933l-4.83 1.294 1.294 4.83 4.83-1.295-1.294-4.83z"
});

var SvgProvider = function SvgProvider(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProvider, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/provider.4eed8141.svg";
export { ForwardRef as ReactComponent };